import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
import { privacyCopy } from '../data/translations/privacy';
export function PrivacyPage() {
  const {
    language
  } = useLanguage();
  const copy = privacyCopy[language];
  return <div className="min-h-screen bg-paper text-ink-600 font-sans selection:bg-bronze-400 selection:text-white" data-id="element-270" data-mp="31zabp19gpy95">
      <Navigation data-id="element-271" data-mp="36xtz763pfi3m" />
      <main className="surface-a relative pt-36 pb-56" data-id="element-272" data-mp="36xbv5nasvzl5">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-273" data-mp="3bp29e4cuz7hu">
          <a href="/" className="inline-flex items-center gap-2 text-bronze-600 hover:text-ink-900 transition-colors text-sm mb-10" data-id="element-274" data-mp="3bpvivd37cb3o">
            <ArrowLeft size={16} data-id="element-275" data-mp="3kqtf397efebp" />
            {copy.back}
          </a>

          <h1 className="font-serif text-4xl md:text-5xl text-ink-900 mb-3" data-id="element-276" data-mp="3polf6qi766qz">
            {copy.heading}
          </h1>
          <p className="text-ink-600 text-sm mb-12" data-id="element-277" data-mp="2yqn8xu4s9xkr">{copy.updated}</p>

          <div className="space-y-10" data-id="element-278" data-mp="2trag8sr8dwa9">
            {copy.sections.map(section => <section key={section.title} data-id="element-279" data-mp="2ttn1besacmrj">
                <h2 className="font-serif text-2xl text-ink-900 mb-3" data-id="element-280" data-mp="2pqqetczmk6ib">
                  {section.title}
                </h2>
                <div className="space-y-3" data-id="element-281" data-mp="2ksgk13htb7x8">
                  {section.body.map((paragraph, index) => <p key={index} className="text-ink-600 text-base leading-relaxed" data-id="element-282" data-mp="3hg3g30az4oa5" data-mpi={index}>
                      {paragraph}
                    </p>)}
                </div>
              </section>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-283" data-mp="33of2stozntrl" />
    </div>;
}